import React, { useEffect, useState, useContext } from "react";
import { Menu, MenuItem, Typography } from "@mui/material";
import {
  IconFlagUS,
  IconFlagES,
  IconFlagCN,
  IconFlagFR,
} from "material-ui-flags";
import CheckIcon from "@mui/icons-material/Check";
import BrowserLanguage from "../Util/BrowserLanguage";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
  REACT_DASHBOARD_PANEL,
  REACT_URL_DASHBOARD,
} from "../../actions/EndPoints";
import { ThemeContext } from "../../theme/ThemeContext";

function SelectLanguageMenu(props) {
  const [image, setImage] = React.useState(props.normalImage);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openMenu, setOpenMenu] = React.useState(false);
  // const [openMenu, setOpenMenu] = React.useState(props.onclickMenu);
  const [search, setSearch] = React.useState(null);
  const [anchorEl2, setanchorEl2] = React.useState(null);
  const { darkMode } = useContext(ThemeContext);
  const [hovered, setHovered] = useState(false);

  const { t, i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState("en");
  const history = useHistory();

  useEffect(() => {
    const currentLanguage = localStorage.getItem("i18nextLng");
    setSelectedLang(currentLanguage);
  }, []);

  useEffect(() => {
    const img = new Image();
    img.src = props.hoverImage;
  }, [props.hoverImage]);

  const handleClick = (event) => {
    setanchorEl2(event.currentTarget);
    setOpenMenu(true);
    setImage(props.onclickImage);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenMenu(false);
    out();
  };

  const over = (e) => {
    setHovered(!hovered);
  };

  const out = (e) => {
    setHovered(!hovered);
  };

  const onMouseOut = (e) => {
    setHovered(!hovered);
  };

  const handleCloseLangMenu = (event) => {
    props.handleClose(null);
    setanchorEl2(event.currentTarget);
    if (event[0] === undefined) {
      BrowserLanguage.getDefaultLanguage();
      setSearch(null);
    } else {
      if (localStorage.getItem("companyType") === "CUSTOMER") {
        localStorage.setItem("i18nextLng", event);
        BrowserLanguage.setLanguage(event);
        i18n.changeLanguage(event);
        setSearch(event);
        setSelectedLang(event);
        history.push({
          pathname: REACT_URL_DASHBOARD,
        });
      } else {
        localStorage.setItem("i18nextLng", event);
        BrowserLanguage.setLanguage(event);
        i18n.changeLanguage(event);
        setSearch(event);
        setSelectedLang(event);
        history.push({
          pathname: REACT_DASHBOARD_PANEL,
        });
      }
    }
    window.location.reload(false);
  };
  return (
    <>
      <MenuItem
        anchorEl={anchorEl2}
        onMouseOver={over}
        onMouseOut={onMouseOut}
        className="profileMenu"
        onClick={(e) => handleClick(e)}
        sx={{
          "&:hover": {
            backgroundColor: "rgba(144, 144, 144, 0.1)",
            "& .MuiTypography-root": {
              color: "#F2824C",
            },
          },
        }}
      >
        <img
          src={hovered ? props.hoverImage : props.normalImage}
          alt={props.alt}
          style={{ paddingRight: "10px" }}
        />
        <Typography
          sx={{
            fontFamily: "font_regular",
            color: props.darkMode ? "rgba(221, 221, 221, 1)" : "#434547",
          }}
        >
          {props.item}
        </Typography>
      </MenuItem>
      <Menu
        anchorEl={anchorEl2}
        id="account-menu"
        open={openMenu}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          paddingRight: 55,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 0,
            mr: 1,
            backgroundColor: darkMode ? "#1c354b" : "background.paper",

            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
            },

            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 18,
              right: -3,
              width: 10,
              height: 10,
              bgcolor: darkMode ? "#1c354b" : "",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "left ", vertical: "top" }}
      >
        <MenuItem
          value={"en"}
          key={"en"}
          onClick={() => {
            handleCloseLangMenu("en");
          }}
          sx={[
            (theme) => ({
              marginRight: "10px",
              marginLeft: "10px",
              "&:hover": {
                background: "#DCFFE980",
              },
            }),
          ]}
        >
          <IconFlagUS className="lang-flag" />
          &nbsp;
          <span style={{ color: darkMode ? "#fff" : "#000" }}>
            {t("i18nLabelEnglishFlag")}
          </span>
          &nbsp;
          {selectedLang === "en" && <CheckIcon style={{ color: "green" }} />}
        </MenuItem>
        <MenuItem
          value={"es"}
          key={"es"}
          onClick={() => {
            handleCloseLangMenu("es");
          }}
          sx={[
            (theme) => ({
              marginRight: "10px",
              marginLeft: "10px",
              "&:hover": {
                background: "#DCFFE980",
              },
            }),
          ]}
        >
          <IconFlagES className="lang-flag" />
          &nbsp;
          <span style={{ color: darkMode ? "#fff" : "#000" }}>
            {t("i18nLabelSpanishFlag")}
          </span>
          {selectedLang === "es" && <CheckIcon style={{ color: "green" }} />}
        </MenuItem>
      </Menu>
    </>
  );
}

export default SelectLanguageMenu;
